export default "__VITE_ASSET__lv_jvqIp__"